export default "__VITE_ASSET__Ybt7Fd6g__"